export default (editor, opts = {}) => {
    const pns = editor.Panels;
  
    pns.addButton('options',{
      id: 'edit',
      className: 'fa fa-edit',
      command: 'edit-code',
      attributes:{
        title: 'edit_code'
      },
      active: false,
    });
    
  }